import { type FlagCode } from '../components/Icon/Flag'

export interface NavItem {
  href: string
  labelKey: string
}

export const NAV_ITEMS: NavItem[] = [
  { href: '#how-it-works', labelKey: 'header.nav.howItWorks' },
  { href: '#easy-sending', labelKey: 'header.nav.easySending' },
  { href: '#benefits', labelKey: 'header.nav.benefits' },
  { href: '#features', labelKey: 'header.nav.features' },
  { href: '#faq', labelKey: 'header.nav.faq' },
]

export interface Language {
  code: string
  flag: FlagCode
  /** Language endonym — intentionally not translated */
  label: string
}

export const LANGUAGES: Language[] = [
  { code: 'uk', flag: 'ua', label: 'Українська' },
  { code: 'en', flag: 'us', label: 'English' },
  { code: 'cs', flag: 'cz', label: 'Čeština' },
]
